<template>
  <div class="top-products">
    <horizontal-bar-chart :chart-data="chartData"></horizontal-bar-chart>
  </div>
</template>
<script>
import HorizontalBarChart from "@/components/admin/dashboard/charts/HorizontalBarChart";
import chartMixin from "@/mixins/dashboard/chartMixin";
export default {
  name: "ProductPriceRanking",
  components: { HorizontalBarChart },
  mixins: [chartMixin],
  props: {
    orders: {
      type: Array,
      default: null
    },
    productTypeSelected: {
      type: String,
      default: null
    }
  },
  computed: {
    chartData() {
      let labels = [];
      let data = [];
      let _products = [];
      //Create single product array
      this.orders.forEach(orderDate => {
        _products = [..._products, ...orderDate.products];
      });
      _products =
        this.productTypeSelected !== "all"
          ? _products.filter(product => {
              if (this.productTypeSelected === this.productTypeIds.drinks) {
                return product.type === "drinks";
              }
              if (this.productTypeSelected === this.productTypeIds.food) {
                return product.type === "food";
              }
              if (this.productTypeSelected === this.productTypeIds.dessert) {
                return product.type === "dessert";
              }
            })
          : _products;
      let resultObj = _products.reduce(function(acc, curr) {
        return (
          curr.product_name
            ? acc[curr.product_name]
              ? (acc[curr.product_name] += curr.price)
              : (acc[curr.product_name] = curr.price)
            : "",
          acc
        );
      }, {});
      for (const [key, value] of Object.entries(resultObj)) {
        labels.push(key);
        data.push(value);
      }
      return {
        labels: labels,
        datasets: [
          {
            label: "Amount",
            data: data,
            fill: false,
            backgroundColor: "#02e0fd",
            borderColor: "#000000",
            pointBorderColor: "white",
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
